import useId from '../utils/useId';
import * as React from 'react';
export const monicaaiSvg = React.forwardRef(function monicaaiSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 28c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12S4 9.371 4 16c0 6.627 5.373 12 12 12Z',
      fill: `url(#bi_monicaai__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 24.437c5.385 0 9.75-3.777 9.75-8.438 0-4.66-4.365-8.438-9.75-8.438S6.25 11.34 6.25 16s4.365 8.438 9.75 8.438Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.207 14.194a.958.958 0 0 1 1.59.297.96.96 0 0 1-.233 1.06l-1.114 1.114 1.473.85a.96.96 0 1 1-.96 1.662l-2.444-1.41a.998.998 0 0 1-.072-.047.962.962 0 0 1-.236-1.53l1.996-1.996Zm-8.519-.258a1.5 1.5 0 0 0-1.5 1.5v2.25a1.5 1.5 0 1 0 3 0v-2.25a1.5 1.5 0 0 0-1.5-1.5Z',
      fill: '#1E1E1E',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_monicaai__a_${id_0}`,
          x1: 4,
          y1: 16.28,
          x2: 28,
          y2: 16.28,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#A83FE0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.477,
          stopColor: '#515FFB',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#2BB5DD',
        }),
      ),
    ),
  );
});
monicaaiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var monicaai = {
  category: 'brand',
  colorable: false,
  name: 'monicaai',
  svg: monicaaiSvg,
};
